import { useMutation } from "@tanstack/react-query";

import { retryVerificationCode } from "~/providers/api/verificationCode";

export const useRetryVerificationCode = () => {
  return useMutation({
    mutationFn: retryVerificationCode,
  });
};
